import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import {
    bindConFeeOrderItem,
    bindConvenienceFeeAmount,
    bindConvenienceFeeSelected,
    bindFinalDonationAmount,
    bindFinalDonationAmountError,
    bindHaslessInstallmentAmt,
    bindInstallmentChargeValue,
    bindInstallmentError,
    bindInstallmentErrorMsg
} from '../../../actions';
import { convenienceFee } from '../styles';
import {
    CalcConvenienceFee as calcConvenienceFee,
    confeeTaxDeductable,
    getDecimalPoint,
    getPaymentAmount,
    removedecimal
} from '../utility/util';


const ConvenienceFee = () => {
    const checkboxStyle = { verticalAlign: 'middle' };

    const convfee = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeSection || {}
    );

    const [ instruction, setInstruction ] = useState('');

    const dispatch = useDispatch();
    const convFeeAmt = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeAmount || ''
    );

    const installments = useSelector(
        state => state['features/clickandpledge']?.installementSelected || ''
    );
    const donationAmount = useSelector(
        state => state['features/clickandpledge']?.donationAmountSelected || ''
    );
    const IsConvFeeSelected = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeSelected
    );
    const conFeeOrderItem = useSelector(
        state => state['features/clickandpledge']?.conFeeOrderItem || {}
    );
    const donationIndex = useSelector(
        state => state['features/clickandpledge']?.donationAmountIndex
    );
    const donationOrderItems = useSelector(
        state => state['features/clickandpledge']?.donationOrderItems || {}
    );

    const recurringselection = useSelector(
        state => state['features/clickandpledge']?.recurringSelection || ''
    );
    const formSettings = useSelector(
        state => state['features/clickandpledge']?.formSettings || {}
    );
    const recuMethod = useSelector(
        state => state['features/clickandpledge']?.recurringMethod || ''
    );
    const haslessInstallmentAmt = useSelector(
        state => state['features/clickandpledge']?.haslessInstallmentAmt || false
    );

    useEffect(() => {
        if (
            donationAmount
      && parseFloat(donationAmount) > 0
      && convfee
      && convfee.AddAdditionalFeeType !== '0'
        ) {
            const donAmt
        = recuMethod !== 'Subscription' && installments
            ? getDecimalPoint(donationAmount, installments, '')
            : parseFloat(donationAmount);

            const calFee = calcConvenienceFee(
        donAmt,
        convfee.AdditionalFeePercentage,
        convfee.AdditionalFeeAmount,
        installments,
        recurringselection,
        convfee.AdjustFee,
        recuMethod
            );

            const additionalFee = calFee;
            const findaddfee = new RegExp('{AdditionalFee}', 'g');
            const findtotfee = new RegExp('{TotalWithAdditionalFee}', 'g');
            const totalWithFee = parseFloat(donationAmount) + parseFloat(additionalFee);
            const inst = convfee.Instruction
                ? convfee.Instruction.replace(
            findaddfee,
            formSettings.Currency + parseFloat(additionalFee).toFixed(2)
                ).replace(
            findtotfee,
            formSettings.Currency + parseFloat(totalWithFee).toFixed(2)
                )
                : '';

            setInstruction(inst);
            const isFeeActive = IsConvFeeSelected || convfee.AddAdditionalFeeType === '1' || convfee.DefaultOpt === '1';

            // Enabled Automatic
            if (convfee && isFeeActive) {
                const DonAmount = getPaymentAmount(
                    donationAmount,
                    recuMethod && recuMethod !== 'Subscription' ? installments : '',
                    calFee,
                    isFeeActive,
                    recuMethod,
                    recurringselection
                );

                dispatch(bindFinalDonationAmount(removedecimal(DonAmount)));

                dispatch(bindInstallmentChargeValue(removedecimal(DonAmount)));
                if (DonAmount > 1) {
                    dispatch(bindFinalDonationAmountError(false));
                }
            }

            dispatch(bindConvenienceFeeAmount(removedecimal(additionalFee)));

            if (isFeeActive) {
                const selectedAmountId = donationOrderItems?.itemId || donationIndex || 183000;
                const feeItemId = (parseInt(selectedAmountId, 10) || 183000) + 1;

                dispatch(
                    bindConFeeOrderItem({
                        itemId: feeItemId,
                        conFeeItemName: convfee.ReceiptDescriptor,
                        conFee: removedecimal(additionalFee),
                        conSKU: convfee.SKU,
                        conGAU: convfee.GAU,
                        taxDeductible: confeeTaxDeductable(additionalFee, formSettings.TaxDeductible ? convfee.TaxDeductible : 0, convfee.AdditionalFeeFMV),
                        postandcombained: convfee.PostAndCombinAdditionalFee
                    })
                );
            } else {
                dispatch(bindConFeeOrderItem({}));
            }
        }
    }, [ convfee, donationAmount, IsConvFeeSelected, installments, Object.keys(conFeeOrderItem).length, donationIndex, donationOrderItems?.itemId ]);

    const addConvFee = () => {
        let amount = 0;

        // If currently selected, toggle to unselected
        if (IsConvFeeSelected) {
            // Uncheck: disable fee
            dispatch(bindConvenienceFeeSelected(false));
            dispatch(bindConFeeOrderItem({}));

            if (installments && recuMethod && recuMethod !== 'Subscription') {
                dispatch(
                    bindFinalDonationAmount(
                        parseFloat(removedecimal(parseFloat(donationAmount) / installments))
                    )
                );
                dispatch(
                    bindInstallmentChargeValue(
                        parseFloat(removedecimal(parseFloat(donationAmount) / installments))
                    )
                );
                amount = parseFloat(
                    removedecimal(parseFloat(donationAmount) / installments)
                );
                if (amount < 1) {
                    dispatch(bindInstallmentError(true));
                    dispatch(bindHaslessInstallmentAmt(true));
                    dispatch(
                        bindInstallmentErrorMsg('Installment amount cannot be less than $1')
                    );
                }
            } else {
                dispatch(bindFinalDonationAmount(donationAmount));
            }
            dispatch(bindConvenienceFeeAmount(''));

            return;
        }

        // If currently unselected, toggle to selected
        const donAmt
            = recuMethod !== 'Subscription' && installments
                ? getDecimalPoint(donationAmount, installments, '')
                : parseFloat(donationAmount);
        const calFee = calcConvenienceFee(
            donAmt,
            convfee.AdditionalFeePercentage,
            convfee.AdditionalFeeAmount,
            installments,
            recurringselection,
            convfee.AdjustFee,
            recuMethod
        );

        if (installments && recuMethod && recuMethod !== 'Subscription') {
            dispatch(
                bindFinalDonationAmount(
                    removedecimal((parseFloat(donationAmount) / installments) + calFee)
                )
            );
            dispatch(
                bindInstallmentChargeValue(
                    removedecimal((parseFloat(donationAmount) / installments) + calFee)
                )
            );
            amount = parseFloat(
                removedecimal((parseFloat(donationAmount) / installments) + calFee)
            );
        } else {
            dispatch(
                bindFinalDonationAmount(
                    removedecimal(parseFloat(donationAmount) + calFee)
                )
            );
            dispatch(
                bindInstallmentChargeValue(
                    removedecimal(parseFloat(donationAmount) + calFee)
                )
            );
            amount = parseFloat(removedecimal(parseFloat(donationAmount) + calFee));
        }

        if (haslessInstallmentAmt && amount > 1) {
            dispatch(bindInstallmentError(false));
            dispatch(bindHaslessInstallmentAmt(false));
        }
        dispatch(bindConvenienceFeeSelected(true));
        dispatch(bindConvenienceFeeAmount(removedecimal(calFee)));
    };

    return (
        <>
            {donationAmount
      && donationAmount > 0
      && convfee
      && convfee.AddAdditionalFeeType !== '0' ? (
                    <>
                        <div className = 'form_input_wrapper'>
                            <label style = { convenienceFee.feeRow }>
                                <input
                                    checked = { Boolean(IsConvFeeSelected || convfee?.AddAdditionalFeeType === '1') }
                                    className = 'additional_fee_checkbox'
                                    disabled = { convfee.AddAdditionalFeeType === '1' }
                                    id = 'inlineCheckbox4'
                                    onChange = { () => addConvFee() }
                                    style = { checkboxStyle }
                                    type = 'checkbox'
                                    value = { convFeeAmt } />
                                {instruction}
                            </label>
                        </div>
                    </>
                ) : null}
        </>
    );
};

export default ConvenienceFee;
